import React, { useEffect, useState, useTransition } from "react";
import "katex/dist/katex.min.css";
// import { MathJax, MathJaxContext } from 'react-mathjax';
import { MathJax } from "better-react-mathjax";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { RotateLoader } from "react-spinners";
import { useCallback } from "react";
import { ToastContainer, toast } from "react-toastify";
// import CategoryComponent from "../../../utils/CategoryComponent";

const AddMockQuestionsNew = () => {

  const { quizId } = useParams();
  const [searchparams, setSearchParams] = useSearchParams();
  const testseriesId = searchparams.get("testseriesId");
  const subjectName = searchparams.get("subName");
  const subjectId = searchparams.get("subId");
  const templateId = searchparams.get("template_id");



  const [questionsList, setQuiestionsList] = useState();
  const [selectedChapter, setSelectedChapter] = useState();
  const [chapterList, setChapterList] = useState();
  const [groupId, setGroupId] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [staticData, setStaticData] = useState();
  const [addLoading, setAddLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [paginationModel, setPaginationModel] = useState({
      page: 0,
      pageSize: 10,
    });
  const [exam_id, setExam_id] = useState("");
  const [course, setCourse] = useState("");
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const [addCloseLoading, setAddCloseLoading] = useState(false);
  const [addContinueLoading, setAddContinueLoading] = useState(false);
  const [isExamLevelCurrentAffair, setIsExamLevelCurrentAffair] = useState(false);
  const [subjectExamId, setSubjectExamId] = useState(null);





  
  // const [paginationModel, setPaginationModel] = useState({
  //   page: 0,
  //   pageSize: 10,
  // });
  // const handleRowSelectionChange = (newRowModel) => {
  //   const startRow = paginationModel.page * paginationModel.pageSize;
  //   const endRow = startRow + paginationModel.pageSize;

  //   const currentPageRows = rows.slice(startRow, endRow).map((row) => row.id);
  //   const newSelectedQuestions = newRowModel;

  //   const allSelectedOnCurrentPage = currentPageRows.every((rowId) =>
  //     newSelectedQuestions.includes(rowId)
  //   );

  //   if (allSelectedOnCurrentPage) {
  //     setSelectedQuestions((prevSelected) => {
  //       const filteredSelection = prevSelected.filter(
  //         (id) => !currentPageRows.includes(id)
  //       );
  //       return [...new Set([...filteredSelection, ...newSelectedQuestions])];
  //     });
  //   } else {
  //     setSelectedQuestions((prevSelected) => {
  //       const updatedSelection = prevSelected.filter(
  //         (id) => !currentPageRows.includes(id)
  //       );
  //       return [...updatedSelection, ...newSelectedQuestions];
  //     });
  //   }
  // };

  useEffect(() => {
    const token = localStorage.getItem("token");
    localStorage.setItem("template_id", templateId);
    localStorage.setItem("subject_id", subjectId);
    


    async function f() {
      const res = await axios.get(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/mock-test/${testseriesId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("testseries Data ", res);
      setStaticData(res?.data?.data);
      setExam_id(res?.data?.data.exam_id);
      setGroupId(res?.data?.data.group_id);
      setCourse(res?.data?.data.course);




    }
    f();

    // return () => {};
  }, [testseriesId]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    
    // Only fetch if we have the required data
    if (!exam_id || !course || !subjectId) {
      console.log("Waiting for data:", { exam_id, course, subjectId });
      return;
    }

    async function fetchChaptersAndQuestions() {
      try {
        console.log("Fetching chapters with:", { exam_id, course, subjectId, subjectExamId });
        const res = await axios.get(
          `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-chapter-by-subject-id/${subjectId}?exam_id=${exam_id}&course=${course}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        console.log("Chapters Data ", res?.data?.data);
        
        if (!res?.data?.data || res.data.data.length === 0) {
          setChapterList([]);
          setSelectedChapter(null);
          setQuiestionsList([]);
          setLoading(false);
          return;
        }
        
        const firstChapterId = res.data.data[0]?.chapter_id;
        setChapterList(res.data.data);
        setSelectedChapter(firstChapterId);
        
        // Fetch questions for the first chapter
        const res2 = await axios.post(
          `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-bulk-mock-test-question`,
          {
            selected_subject_id: subjectId,
            chapter_id: firstChapterId,
            mock_test_id: quizId,
            exam_id: exam_id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        console.log("Questions Data ", res2?.data?.data);
        setQuiestionsList(res2?.data?.data);
        setShuffledQuestions([]);
        setSelectedRows([]);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching chapters and questions:", error);
        setLoading(false);
      }
    }
    
    fetchChaptersAndQuestions();
  }, [subjectId, exam_id, course, quizId]);

  // Fetch exam data by subject to get exam_id
  useEffect(() => {
    const fetchExamBySubject = async () => {
      if (!subjectId) return;

      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_LIVE_URL_NEW}/admin/exam/by-subject`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            params: {
              subject_id: subjectId
            }
          }
        );

        if (response.data && response.data.data && response.data.data.exam_id) {
          const examId = response.data.data.exam_id;
          setSubjectExamId(examId);

          // Check if it's exam level current affair (exam_id 44)
          setIsExamLevelCurrentAffair(examId === 44);

          console.log("Fetched exam_id from subject:", examId);
        }
      } catch (error) {
        console.error("Error fetching exam by subject:", error);
        setSubjectExamId(null);
        setIsExamLevelCurrentAffair(false);
      }
    };

    fetchExamBySubject();
  }, [subjectId]);

  // console.log("selectMenus",selectMenus)

  console.log("Is exam level current affair:", isExamLevelCurrentAffair);

  const columns = [
    {
      field: "question_title",
      headerName: "Questions",
      renderCell: ({ row }) => {
        // console.log("this is my row", row.row);

        const { options } = row?.row;
        let decodedContent;
        try {
          decodedContent = decodeURIComponent(row?.question_title);
        } catch (error) {
          // Handle the decoding error here
          // You can set a default value or handle the error in another way if needed
          decodedContent = "Unable to decode content";
        }
        return (
          <Stack
            // margin={"1rem"}
            fontSize={"0.9rem"}
            spacing={3}
            style={{ width: "65vw" }}
          >
            <Stack spacing={1}>
              <MathJax
                style={{
                  display: "flex",
                  padding: "10 0 10 0",
                  // alignContent: "center",
                  justifyItems: "center",
                  cursor: "pointer"
                }}
              >
                <p
                  className="text-lg"
                  style={{
                    display: "inline",
                    paddingRight: "1rem",
                  }}
                  dangerouslySetInnerHTML={{ __html: row?.question_title }}
                ></p>
              </MathJax>
            </Stack>
        
          </Stack>
        );
      },
      renderHeader: () => (
        <Stack
          direction={"row"}
          width={"70vw"}
          justifyItems={"center"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <h1 style={{ fontSize: "18px" }}>Questions List</h1>
          <Button
            variant="contained"
            disabled={addCloseLoading}
            size="small"
            style={{
              width: "10%",
              margin: "auto 0 auto auto",
              height: "fit-content",
            }}
            onClick={(e) => {
              if (addCloseLoading) return; //agar questions add ho rahe h to disable krdo isko and loader laga do

              e.preventDefault();
              e.stopPropagation(); // this is done so that on clicking the add button the parent component which is header doesn't gets clicked other wise it will change the order of the questions, you may comment above 2 lines to check what will happen.
              addSelectedQuestions();
            }}
          >
            {addCloseLoading ? <CircularProgress size={"2rem"} /> : "Add and Close"}
          </Button>

          <Button
            variant="contained"
            disabled={addContinueLoading}
            size="small"
            style={{
              width: "12%",
              margin: "auto 0 auto 1rem",
              height: "fit-content",
            }}
            onClick={(e) => {
              if (addContinueLoading) return;

              e.preventDefault();
              e.stopPropagation();

              addSelectedQuestions(false); // Disable redirection in this case
            }}
          >
            {addContinueLoading ? (
              <CircularProgress size={"2rem"} />
            ) : (
              "Add and Continue"
            )}
          </Button>

             <Button
      variant="outlined"
      size="small"
      style={{
        marginLeft: "1rem",
        height: "fit-content",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        shuffleQuestions();
      }}
    >
      Shuffle
    </Button>

    <Button
      variant="outlined"
      size="small"
      style={{
        marginLeft: "1rem",
        height: "fit-content",
        backgroundColor: areAllCurrentPageSelected() ? "#e3f2fd" : "transparent",
        borderColor: "#1976d2",
        color: "#1976d2",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSelectAllCurrentPage();
      }}
    >
      {areAllCurrentPageSelected() ? "Deselect Page" : "Select Page"}
    </Button>
        </Stack>
      ),
      width: "auto",

      
    },

    
  ];


  const shuffleQuestions = () => {
    if (!questionsList || questionsList.length === 0) return;
  
    const shuffled = [...questionsList].sort(() => Math.random() - 0.5);
    setShuffledQuestions(shuffled);
    
    // Preserve selected questions after shuffling
    // No need to clear selections as the question IDs remain the same
  };

  // Function to select/deselect all questions on current page
  const handleSelectAllCurrentPage = () => {
    const startIndex = paginationModel.page * paginationModel.pageSize;
    const endIndex = startIndex + paginationModel.pageSize;
    const currentPageRows = rows.slice(startIndex, endIndex);
    const currentPageQuestionIds = currentPageRows.map(row => row.id);
    
    // Check if all current page questions are already selected
    const allCurrentPageSelected = currentPageQuestionIds.every(id => selectedRows.includes(id));
    
    if (allCurrentPageSelected) {
      // Deselect all current page questions
      const newSelectedRows = selectedRows.filter(id => !currentPageQuestionIds.includes(id));
      setSelectedRows(newSelectedRows);
      
      // Update global selections - remove current page selections, keep others
      const currentChapterQuestionIds = rows.map(row => row.id);
      const selectionsFromOtherChapters = selectedQuestions.filter(id => !currentChapterQuestionIds.includes(id));
      const newGlobalSelections = [...selectionsFromOtherChapters, ...newSelectedRows];
      setSelectedQuestions(newGlobalSelections);
    } else {
      // Select all current page questions
      const newSelectedRows = [...new Set([...selectedRows, ...currentPageQuestionIds])];
      setSelectedRows(newSelectedRows);
      
      // Update global selections - combine with current page selections
      const currentChapterQuestionIds = rows.map(row => row.id);
      const selectionsFromOtherChapters = selectedQuestions.filter(id => !currentChapterQuestionIds.includes(id));
      const newGlobalSelections = [...selectionsFromOtherChapters, ...newSelectedRows];
      setSelectedQuestions(newGlobalSelections);
    }
  };

  // Function to check if all current page questions are selected
  const areAllCurrentPageSelected = () => {
    const startIndex = paginationModel.page * paginationModel.pageSize;
    const endIndex = startIndex + paginationModel.pageSize;
    const currentPageRows = rows.slice(startIndex, endIndex);
    const currentPageQuestionIds = currentPageRows.map(row => row.id);
    
    return currentPageQuestionIds.length > 0 && currentPageQuestionIds.every(id => selectedRows.includes(id));
  };
  

  const rows =
  (shuffledQuestions.length > 0 ? shuffledQuestions : questionsList)?.map((question) => ({
    id: question?.question_id,
    question_title: question?.question_title,
    row: question,
  })) || [];


  const handleSearch = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!subjectId || !selectedChapter) return;
    setLoading(true);

    const res = await axios.post(
      `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-bulk-mock-test-question`,
      {
        selected_subject_id: subjectId,
        chapter_id: selectedChapter,
        mock_test_id: quizId,
        exam_id: subjectExamId || exam_id,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("bulk quiz questions", res);
    setQuiestionsList(res?.data?.data);
    setShuffledQuestions([]);
    
    // Keep ALL previously selected questions from all chapters
    // Only update selectedRows to show current chapter's selections
    const newQuestionIds = res?.data?.data?.map(q => q.question_id) || [];
    const currentChapterSelections = selectedQuestions.filter(id => newQuestionIds.includes(id));
    setSelectedRows(currentChapterSelections);
    
    // Show info about selections from other chapters
    const selectionsFromOtherChapters = selectedQuestions.length - currentChapterSelections.length;
    if (selectionsFromOtherChapters > 0) {
      toast.info(`${selectionsFromOtherChapters} question(s) selected from other chapters will be preserved. Total selected: ${selectedQuestions.length}`);
    }
    
    // Don't clear selectedQuestions - keep all selections from all chapters
    // selectedQuestions remains unchanged to preserve cross-chapter selections

    setLoading(false);
  }, [selectedChapter, subjectId, selectedQuestions, subjectExamId, exam_id]);

   async function addSelectedQuestions(shouldRedirect = true) {
     if (!Array.isArray(selectedQuestions) || selectedQuestions.length === 0) {
       toast.warning("Please select questions to add!!");
       return;
     }
     if (shouldRedirect) {
      setAddCloseLoading(true);
     } else {
      setAddContinueLoading(true);
     }
     // console.log("quiz id", quizId);
     const token = localStorage.getItem("token");
     const authToken = token;
     const config = {
       headers: {
         "content-type": "application/json",
         Authorization: `Bearer ${authToken}`,
       },
     };
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/add-question/${quizId}`,
        {
          question_id: selectedQuestions,
          //   testseries_id: testseriesId,
          subject_id: subjectId,
          subject_template_id: templateId,
        },
        config
      );
      if (shouldRedirect) {
        setAddCloseLoading(false);
      } else {
        setAddContinueLoading(false);
      }
      console.log("Response after adding:", res);
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);
        // Remove added questions from selection and table
        if (Array.isArray(selectedQuestions)) {
          // Remove added questions from selectedQuestions and selectedRows
          const addedIds = selectedQuestions;
          setSelectedQuestions(prev => prev.filter(id => !addedIds.includes(id)));
          setSelectedRows(prev => prev.filter(id => !addedIds.includes(id)));
          // Remove added questions from questionsList/shuffledQuestions
          setQuiestionsList(prev => prev ? prev.filter(q => !addedIds.includes(q.question_id)) : prev);
          setShuffledQuestions(prev => prev ? prev.filter(q => !addedIds.includes(q.question_id)) : prev);
        }
        if (shouldRedirect) {
          setTimeout(() => {
            window.history.back();
          }, 700);
        }
        // If shouldRedirect is false (Add and Continue), keep selections except for added ones
      } else {
        toast.error(res?.data?.data?.message);
      }
    } catch (error) {
      if (shouldRedirect) {
        setAddCloseLoading(false);
      } else {
        setAddContinueLoading(false);
      }
      console.error("Error updating test:", error);
      toast.error("Failed to update test. Please try again.");
    }
   }



  
  
  // const handleRowSelectionChange = (newSelection) => {
  //   const visibleRows = rows.slice(
  //     paginationModel.page * paginationModel.pageSize,
  //     (paginationModel.page + 1) * paginationModel.pageSize
  //   );
  //   const visibleRowIds = visibleRows.map((row) => row.id);

  //   // Filter selected rows only for the current page
  //   const newSelectedRows = newSelection.filter((id) =>
  //     visibleRowIds.includes(id)
  //   );

  //   // Update the state with selections from the current page only
  //   setSelectedRows(newSelectedRows);

  //   // Combine the selections from previous pages with the new selections for the current page
  //   const updatedSelectedQuestions = [
  //     ...selectedQuestions.filter((id) => !visibleRowIds.includes(id)), // Keep selections from other pages
  //     ...newSelectedRows, // Add selections from the current page
  //   ];

  //   setSelectedQuestions(updatedSelectedQuestions); // Update the global selected questions state
  // };


  return (
    <div>
      <Stack>
        <h1>
          Select Questions to Add:{" "}
          <span style={{ fontSize: "1rem", color: "blue" }}>
            Total Selected: {selectedQuestions.length}
          </span>
          {selectedRows.length > 0 && (
            <span style={{ fontSize: "0.9rem", color: "green", marginLeft: "10px" }}>
              (Current Chapter: {selectedRows.length})
            </span>
          )}
          <span style={{
            fontSize: "0.9rem",
            color: isExamLevelCurrentAffair ? "orange" : "gray",
            marginLeft: "15px",
            fontWeight: "bold"
          }}>
            {isExamLevelCurrentAffair ? "📅 Exam Level Current Affair Subject" : "📚 Regular Subject"}
          </span>
        </h1>

        <Stack className="search_component" marginY={"2rem"} direction={"row"}>
          <Stack direction={"row"} width={"80%"} spacing={3}>
        
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                {staticData?.course}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={examCategory}
                label={staticData?.course}
                disabled
              ></Select>
            </FormControl>
            {(staticData?.boards_name || staticData?.state_name) && (
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {staticData?.boards_name || staticData?.state_name}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={examCategory}
                  label={staticData?.boards_name || staticData?.state_name}
                  disabled
                ></Select>
              </FormControl>
            )}
            <FormControl fullWidth>
              <InputLabel id="exam_name">
                {staticData?.exam_name || staticData?.classes_name}
              </InputLabel>
              <Select
                labelId="exam_name"
                id="exam_name_select"
                // value={examName}
                disabled
                label={staticData?.exam_name || staticData?.classes_name}
              ></Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="subject">{subjectName}</InputLabel>
              <Select
                labelId="subject"
                id="subject_select"
                label={subjectName}
                disabled
              ></Select>
            </FormControl>
            <FormControl fullWidth>
              {chapterList && (
                <Autocomplete
                  // disablePortal
                  id="chapter-list"
                  options={chapterList}
                  defaultValue={chapterList[0] || null}
                  getOptionLabel={(option) =>
                    `${chapterList.indexOf(option) + 1}. ${option.name} - (${
                      option.count || 0
                    })`
                  }
                  onChange={(e, val) => {
                    setSelectedChapter(val?.chapter_id);
                    // setPaginationModel({page:0,pageSize:10})
                  }}
                  // sx={{ width: 600 }}
                  renderInput={(params) => (
                    <TextField {...params} label="Chapter" />
                  )}
                />
              )}
            </FormControl>
          </Stack>
          <Button
            onClick={handleSearch}
            disabled={loading}
            variant={"contained"}
            style={{ margin: "0 1rem 0 auto", width: "15%", fontSize: "1rem" }}
          >
            Search
          </Button>
        </Stack>

        {rows && columns && !loading ? (
          rows?.length > 0 ? (
            // <MathJaxContext config={config}>
            <DataGrid
              rows={rows}
              getRowHeight={() => "auto"}
              disableRowSelectionOnClick
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[5, 10, 15, 20, 30, 50, 100]}
              checkboxSelection
               onRowSelectionModelChange={(newSelection) => {
    // Update selectedRows (current chapter selections)
    setSelectedRows(newSelection);
    
    // Update global selectedQuestions by combining:
    // 1. Previous selections from other chapters (not in current chapter)
    // 2. New selections from current chapter
    const currentChapterQuestionIds = rows.map(row => row.id);
    const selectionsFromOtherChapters = selectedQuestions.filter(id => !currentChapterQuestionIds.includes(id));
    const newGlobalSelections = [...selectionsFromOtherChapters, ...newSelection];
    
    setSelectedQuestions(newGlobalSelections);
  }}
              paginationModel={paginationModel}
              onPaginationModelChange={(newPaginationModel) =>
                setPaginationModel(newPaginationModel)
              }
              rowSelectionModel={selectedRows}
              onCellClick={(params) => {
                const clickedRowId = params.row.id;
                // If the clicked cell is in the 'question_title' column, toggle the row selection
                if (params.field === 'question_title') {
                  const isRowSelected = selectedRows.includes(clickedRowId);
                  let updatedSelectedRows;
                  if (isRowSelected) {
                    updatedSelectedRows = selectedRows.filter((id) => id !== clickedRowId);
                  } else {
                    updatedSelectedRows = [...selectedRows, clickedRowId];
                  }
                  setSelectedRows(updatedSelectedRows);
                  
                  // Update global selectedQuestions by combining:
                  // 1. Previous selections from other chapters (not in current chapter)
                  // 2. Updated selections from current chapter
                  const currentChapterQuestionIds = rows.map(row => row.id);
                  const selectionsFromOtherChapters = selectedQuestions.filter(id => !currentChapterQuestionIds.includes(id));
                  const newGlobalSelections = [...selectionsFromOtherChapters, ...updatedSelectedRows];
                  
                  setSelectedQuestions(newGlobalSelections);
                }
              }}

             
            />
          ) : (
            <h2>No Questions Available</h2>
          )
        ) : (
          <>
            <div
              style={{
                display: "flex",
                marginTop: "6rem",
                justifyContent: "center",
                width: "auto",
              }}
            >
              <RotateLoader color="#2065D1" />
            </div>
          </>
        )}
      </Stack>
      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default AddMockQuestionsNew;
